import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';

const ITEMS_PER_PAGE = 20;

const CustomStoreFromURL = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  const csvUrl = '../adult-list-menu.csv'; // ✅ Replace with actual path

  useEffect(() => {
    const fetchCSV = async () => {
      
      try {
        const response = await fetch(csvUrl);
        const csvText = await response.text();

        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            if (results.meta.fields?.[0].includes('<!DOCTYPE')) {
              throw new Error("CSV URL returned an HTML page");
            }

            setProducts(results.data);
            setLoading(false);
          }
        });
      } catch (err) {
        console.error('Failed to fetch or parse CSV:', err);
        setLoading(false);
      }
    };

    fetchCSV();
  }, []);

  const handleSelectChange = (index, field, value) => {
    setSelectedOptions(prev => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value
      }
    }));
  };

  const addToCart = (product, index) => {
    const selected = selectedOptions[index];
    if (!selected?.color || !selected?.size) {
      alert("Please select both color and size.");
      return;
    }

    const cartItem = {
      ...product,
      selectedColor: selected.color,
      selectedSize: selected.size
    };

    const existingCart = JSON.parse(localStorage.getItem('cart-customer-online')) || [];
    existingCart.push(cartItem);
    localStorage.setItem('cart-customer-online', JSON.stringify(existingCart));
    alert(`${product.Title || product.Name} (${selected.size}, ${selected.color}) added to cart`);
  };

  const totalPages = Math.ceil(products.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const productsToDisplay = products.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  if (loading) return <p>Loading products...</p>;

  return (
    <div style={{ padding: '20px' }}>
      <h2>Customer Store</h2>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '20px',
        marginTop: '30px'
      }}>
        {productsToDisplay.map((product, index) => {
          const actualIndex = startIndex + index;
          const colorOptions = (product.Color || '')
            .split(',')
            .map(c => c.trim())
            .filter(Boolean);

          const sizeMatch = product['AVAILABLE_SIZES'] || product['Size'] || '';
          const sizeOptions = sizeMatch
            .replace(/[^\w-,]/g, '')
            .split(',')
            .map(s => s.trim())
            .filter(Boolean);

          const selected = selectedOptions[actualIndex] || {};
          const price = parseFloat(product.Price) || 0;
          const salePrice = parseFloat(product.salePrice) || 0;
          const hasSale = salePrice > 0 && salePrice < price;

          return (
            <div key={actualIndex} style={{
              border: '1px solid #ccc',
              borderRadius: '10px',
              padding: '10px',
              textAlign: 'center',
              boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
            }}>
              <img
                src={product.img || 'https://via.placeholder.com/300x200?text=No+Image'}
                alt={product.Title2 || product.Name}
                style={{ width: 150, objectFit: 'cover', borderRadius: '6px' }}
                onError={(e) => e.target.style.display = 'none'}
              />
              <h4>{product.Title || product.Name}</h4>
              <p>{sizeMatch}</p>
              <p style={{ fontWeight: 'bold' }}>
                ${hasSale ? salePrice.toFixed(2) : price.toFixed(2)}
              </p>
              {hasSale && (
                <p style={{ textDecoration: 'line-through', color: 'gray', fontSize: 12 }}>
                  ${price.toFixed(2)}
                </p>
              )}

              {sizeOptions.length > 0 && (
                <div style={{ marginBottom: 8 }}>
                  <select
                    value={selected.size || ''}
                    onChange={(e) => handleSelectChange(actualIndex, 'size', e.target.value)}
                  >
                    <option value="">Select Size</option>
                    {sizeOptions.map((size, i) => (
                      <option key={i} value={size}>{size}</option>
                    ))}
                  </select>
                </div>
              )}

              {colorOptions.length > 0 && (
                <div style={{ marginBottom: 10 }}>
                  <select
                    value={selected.color || ''}
                    onChange={(e) => handleSelectChange(actualIndex, 'color', e.target.value)}
                  >
                    <option value="">Select Color</option>
                    {colorOptions.map((color, i) => (
                      <option key={i} value={color}>{color}</option>
                    ))}
                  </select>
                </div>
              )}

              <button
                onClick={() => addToCart(product, actualIndex)}
                style={{
                  background: 'black',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '5px',
                  border: 'none',
                  cursor: 'pointer'
                }}
              >
                Add to Cart
              </button>
            </div>
          );
        })}
      </div>

      {/* Pagination Controls */}
      <div style={{ marginTop: 30, textAlign: 'center' }}>
        <button
          onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
          disabled={currentPage === 1}
          style={{ marginRight: 10, padding: '8px 16px' }}
        >
          Previous
        </button>
        <span style={{ margin: '0 10px' }}>Page {currentPage} of {totalPages}</span>
        <button
          onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
          disabled={currentPage === totalPages}
          style={{ marginLeft: 10, padding: '8px 16px' }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default CustomStoreFromURL;
